import { gql } from '@apollo/client';

export const fetchInvoiceGroupsForSoldToAddressNames = gql`
  query fetchInvoiceGroupsForSoldToAddressNames(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
  ) {
    transactionAccount(id: $id) {
      id
      billingProfiles(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
        nodes {
          id
          name
          invoiceGroupNumber
          shipToParty {
            id
            name
            addressLine1
            addressLine2
            city
            country
            state
            phone
            postcode
          }
        }
      }
    }
  }
`;
